import React from "react";
import type { CelestialBodyDefinition } from "../../types/celestialBody";
import type { VisualizationScale } from "../../types/astronomy";
import { CelestialBodyMesh } from "./CelestialBody";

interface MoonProps {
  definition: CelestialBodyDefinition;
  scale: VisualizationScale;
  selected: boolean;
  onSelect: (bodyId: string) => void;
}

export function Moon(props: MoonProps) {
  return <CelestialBodyMesh {...props} />;
}
